import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';

import { environment } from '@env/environment';
import { IGame } from '@courses/interfaces';
import { Game } from '@courses/entities';

@Injectable({
  providedIn: 'root',
})
export class GameService {
  constructor(private http: HttpClient) {}

  getGames(
    courseId: number,
    filters: HttpParams | { [params: string]: string | string[] } = {},
    isSilentLoader = false
  ) {
    return this.http
      .get<any>(`${environment.apiUrl}courses/${courseId}/games/`, {
        params: filters,
        headers: { 'silent-loader': isSilentLoader ? 'true' : 'false' },
      })
      .pipe(map(res => ({ ...res, results: res.results.map((game: IGame) => new Game(game)) })));
  }
}
